export default __webpack_public_path__ + "93db45f74b0eac9fd89e7172cdab5218.svg";